module.exports = __webpack_public_path__ + "img/V-45-ST-1000-N.5d5556eb.png";